/* eslint-disable import/no-cycle */
import comparisonSchema from './comparison/schema';
import listSchema from './list/schema';
import showcaseSchema from './showcase/schema';
import slimSchema from './slim/schema';
import tableSchema from './table/schema';

const formSchema = {
  comparison: comparisonSchema,
  showcase: showcaseSchema,
  slim: slimSchema,
  list: listSchema,
  table: tableSchema,
};

export default formSchema;
export type SchemaType = typeof formSchema;
